"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftOwnershipToJSON = exports.NftOwnershipFromJSONTyped = exports.NftOwnershipFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NftOwnershipFromJSON(json) {
    return NftOwnershipFromJSONTyped(json, false);
}
exports.NftOwnershipFromJSON = NftOwnershipFromJSON;
function NftOwnershipFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'nftGroupingId': !(0, runtime_1.exists)(json, 'nftGroupingId') ? undefined : json['nftGroupingId'],
        'nftTrackerId': json['nftTrackerId'],
        'registrySigningId': json['registrySigningId'],
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'nftId': json['nftId'],
        'tokenUri': !(0, runtime_1.exists)(json, 'tokenUri') ? undefined : json['tokenUri'],
        'tokenImageUrl': !(0, runtime_1.exists)(json, 'tokenImageUrl') ? undefined : json['tokenImageUrl'],
        'nftGroupingIndex': !(0, runtime_1.exists)(json, 'nftGroupingIndex') ? undefined : json['nftGroupingIndex'],
        'burnedAt': !(0, runtime_1.exists)(json, 'burnedAt') ? undefined : json['burnedAt'],
        'redeemedAt': !(0, runtime_1.exists)(json, 'redeemedAt') ? undefined : json['redeemedAt'],
        'redeemRecord': !(0, runtime_1.exists)(json, 'redeemRecord') ? undefined : json['redeemRecord'],
        'transactionHash': !(0, runtime_1.exists)(json, 'transactionHash') ? undefined : json['transactionHash'],
        'nftTrackerIndex': !(0, runtime_1.exists)(json, 'nftTrackerIndex') ? undefined : json['nftTrackerIndex'],
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
        'isVirtual': !(0, runtime_1.exists)(json, 'isVirtual') ? undefined : json['isVirtual'],
        'isEligibleForCompetitions': !(0, runtime_1.exists)(json, 'isEligibleForCompetitions') ? undefined : json['isEligibleForCompetitions'],
        'ofCurrentCommunity': !(0, runtime_1.exists)(json, 'ofCurrentCommunity') ? undefined : json['ofCurrentCommunity'],
        'tracker': !(0, runtime_1.exists)(json, 'tracker') ? undefined : (0, _1.NftTrackerFromJSON)(json['tracker']),
    };
}
exports.NftOwnershipFromJSONTyped = NftOwnershipFromJSONTyped;
function NftOwnershipToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'nftGroupingId': value.nftGroupingId,
        'nftTrackerId': value.nftTrackerId,
        'registrySigningId': value.registrySigningId,
        'userId': value.userId,
        'nftId': value.nftId,
        'tokenUri': value.tokenUri,
        'tokenImageUrl': value.tokenImageUrl,
        'nftGroupingIndex': value.nftGroupingIndex,
        'burnedAt': value.burnedAt,
        'redeemedAt': value.redeemedAt,
        'redeemRecord': value.redeemRecord,
        'transactionHash': value.transactionHash,
        'nftTrackerIndex': value.nftTrackerIndex,
        'notes': value.notes,
        'isVirtual': value.isVirtual,
        'isEligibleForCompetitions': value.isEligibleForCompetitions,
        'ofCurrentCommunity': value.ofCurrentCommunity,
        'tracker': (0, _1.NftTrackerToJSON)(value.tracker),
    };
}
exports.NftOwnershipToJSON = NftOwnershipToJSON;
